import { createStyles, Theme } from '@material-ui/core/styles';

const styles = ({ colors, spacing, breakpoints }: Theme) => createStyles({
  root: {
    marginTop: spacing(8),
    width: 600,
    [breakpoints.up('lg')]: {
      width: 740,
    },
    [breakpoints.up('xl')]: {
      width: 936,
    },
  },
  title: {
    marginTop: spacing(2),
    marginBottom: spacing(2),
  },
  message: {
    color: colors.text.secondary,
    marginBottom: spacing(4),
  },
  button: {
    marginTop: spacing(6),
  },
  supportEmail: {
    marginTop: spacing(4),
  },
});

export default styles;
